import { render, staticRenderFns } from "./FirstInitMsg.vue?vue&type=template&id=8c84e82c&"
import script from "./FirstInitMsg.vue?vue&type=script&lang=js&"
export * from "./FirstInitMsg.vue?vue&type=script&lang=js&"
import style0 from "./FirstInitMsg.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports